export default function JsonLd({ id, data }) {
  return (
    <script
      type="application/ld+json"
      data-jsonld={id}
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
